import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import Styled from 'styled-components';

import errorIcon from '@/public/icons/error-icon.svg';
import {colorPalette} from '@/themes/darkmode';

class ErrorBoundary extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        t: PropTypes.func,
        children: PropTypes.any,
        errContentPrefix: PropTypes.element,
    };

    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // You can also log error messages to an error reporting service here
    }

    render() {
        const props = this.props;
        const { t } = this.props;

        if (this.state.errorInfo) {
            // Error path
            return (
                <div className={`error-boundary ${props.className}`}>
                    <h2>{t(['Oops, something went wrong!', 'global.errorMessage'])}</h2>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

//language=SCSS
ErrorBoundary = Styled(ErrorBoundary)`
& {
    padding: 20px 20px 20px 90px;
    border-radius: 10px;
    margin: 20px;
    background-color:${colorPalette.danger};
    background-image: url(${errorIcon});
    background-repeat: no-repeat;
    background-position: 20px 20px;
    background-size:50px;
    
    h2 {
        font-size:20px;
    }
}
`;

export default withTranslation()(ErrorBoundary);
